<template>
  <div>
    <v-dialog :value="value" @input="$emit('input')" max-width="1300px">
      <!-- brief confirmation -->
      <v-card>
        <v-toolbar flat>
          <v-toolbar-title>Push Campaign to Review</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon aria-label="Close push to review modal" @click="closeModal">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <!-- invoices, brief and confirmation -->
          <invoices-brief-confirmation
            :viewCampaignID="viewCampaignID"
            @confirmBrief="confirmBrief"
            @closeBriefModal="closeModal"
            :isView="true"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="closeModal"> Close </v-btn>
          <v-btn color="primary" @click="openUpdateCampaignQuarterModal">
            Push to Review
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Update Creator Email Modal -->
    <update-campaign-quarter-modal
    v-model="campaignQuarterDialog"
    :value="campaignQuarterDialog"
    :campaignID="viewCampaignID"
    @updated="confirmBrief" />
  </div>
</template>
<script>
import campaignAPIs from '../campaignAPIs';
import InvoicesBriefConfirmation from './InvoicesBriefConfirmation.vue';
import UpdateCampaignQuarterModal from '../UpdateCampaignQuarterModal'
import config from '@/config';
export default {
  name: 'InvoicesBriefViewModal',
  components: {
    InvoicesBriefConfirmation,
    UpdateCampaignQuarterModal
  },
  props: {
    value: Boolean,
    campaignID: String
  },
  data () {
    return {
      isLoading: false,
      campaignQuarterDialog: false,
      viewCampaignID: ''
    }
  },
  watch: {
    campaignID(value) {
      this.viewCampaignID = value
    }
  },
  methods: {
    confirmBrief: function() {
      campaignAPIs
        .changeStatus(this.viewCampaignID, config.campaignStatus.REVIEW)
        .then(response => {
          if (response.success) {
            this.$emit('updated', true)
            this.$emit('input')
            this.$swal({
              title: 'Success',
              text: 'Campaign Status Changed. Do you want to go to updated stage?',
              type: 'success',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Yes',
              cancelButtonText: 'No, Stay here'
            }).then((result) => {
              if (result.value) {
                this.$router.push({ name: this.displayStatus(config.campaignStatus.REVIEW) }) // because router name is same with campaign display name
              } else {
                this.$emit('reload')
              }
            })
          } else {
            this.$swal('Campaign Status Changed Failed')
          }
        })
        .catch(err => console.error(err));
    },
    openUpdateCampaignQuarterModal() {
      this.$swal({
        title: 'Push to Review',
        html: 'Are you sure you want to push to review stage',
        confirmButtonText: 'Confirm',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(async (result) => {
        if (result.value) {
          this.campaignQuarterDialog = true
        }
      })
    },
    displayStatus(status) {
      return config.campaignStatusDisplay[status]['display'] + ' campaigns'
    },
    closeModal: function () {
      this.$emit('input')
    }
  }
}
</script>



// WEBPACK FOOTER //
// InvoicesBriefViewModal.vue?611cc520